import {
  fetchMissions,
  cancelLiveAndQueueMission,
  changeMissionOrder,
  reorderFleetQueue,
  setHotJob,
} from "./actions";
import {
  getMissionsPageFleetId,
  getMissions,
  getIsMissionsUpdatesPaused,
  getMissionsUpdatesStorage,
  getMissionById,
} from "./selectors";
import MissionsQueueSlice from "./reducers";

// actions
export const {
  setMissions,
  setMissionsPageFleetId,
  updateMissions,
  resetMissions,
  reorderMissions,
  moveMissionToVehicle,
  pauseMissionsUpdates,
  continueMissionsUpdates,
  resetMissionsUpdatesStorage,
  resetMissionsPageData,
  setMissionHot,
  clearMissionHot,
  refreshMissionPlanFields,
} = MissionsQueueSlice.actions;

// async actions
export {
  fetchMissions,
  cancelLiveAndQueueMission,
  changeMissionOrder,
  reorderFleetQueue,
  setHotJob,
};

// selectors
export {
  getMissionsPageFleetId,
  getMissions,
  getIsMissionsUpdatesPaused,
  getMissionsUpdatesStorage,
  getMissionById,
};

// reducer
export default MissionsQueueSlice.reducer;

// constants
export const UNASSIGNED_MISSIONS_KEY = "unassigned";
